global?.modules?.set({
  name: 'header',
  is_booted: false,
  init() {
    if (this.is_booted) return;
    this.is_booted = true;

    initBurgerMenu();
    initDropdownMobileClose();
    initDropdownLogic();
    initHeaderScroll();

    function initBurgerMenu() {
      const burger = document.querySelector('.header__burger');
      if (!burger) return;

      burger.addEventListener('click', () => {
        const open = document.documentElement.classList.toggle('menu-open');
        open ? bodyLock() : bodyUnlock();
        if (!open) {
          const active = document.querySelector('[data-dropdown-menu].active');
          active?.classList.remove('active');
        }
      });
    }

    function initDropdownMobileClose() {
      document
        .querySelectorAll('[data-dropdown-menu] .header-dropdown__menu-title')
        .forEach(btn =>
          btn.addEventListener('click', () => {
            const menu = btn.closest('[data-dropdown-menu]');
            menu.classList.remove('active');
            menu.scrollTop = 0;
          })
        );
    }

    function initDropdownLogic() {
      const headerEl = document.querySelector('header.header');
      const btns = document.querySelectorAll('[data-dropdown-trigger]');
      const menus = document.querySelectorAll('[data-dropdown-menu]');
      const noDropdowns = document.querySelectorAll('[data-dropdown-menu-no]');
      if (!headerEl || !btns.length) return;

      let activeBtn = null;
      const HIDE_EVENT = new CustomEvent('hideMenu');

      const closeAll = () => menus.forEach(m => {
        m.hidden = true;
        m.classList.remove('active');
      });

      const openMenu = btn => {
        const key = btn.dataset.dropdownTrigger;
        const m = document.querySelector(`[data-dropdown-menu="${key}"]`);
        if (!m) return;
        const hdrH = headerEl.offsetHeight;
        const maxH = window.innerHeight - hdrH - 100;
        m.hidden = false;
        m.classList.add('active');
        m.closest('.header-dropdown')?.style.setProperty('max-height', maxH + 'px');
      };

      const hideAll = () => {
        if (!activeBtn) return;
        activeBtn.classList.remove('active');
        bodyUnlock();
        headerEl.classList.remove('is-open-menu');
        closeAll();
        activeBtn = null;
      };

      // PC logic
      const media = window.matchMedia('(min-width: 79.9988em)');
      const pcEnter = e => {
        const btn = e.currentTarget;
        if (btn === activeBtn) return;
        activeBtn?.classList.remove('active');
        activeBtn = btn;
        btn.classList.add('active');
        bodyLock();
        closeAll();
        openMenu(btn);
      };

      const bindPC = () => {
        headerEl.addEventListener('mouseleave', hideAll);
        noDropdowns.forEach(n => n.addEventListener('mouseenter', hideAll));
        menus.forEach(m => m.addEventListener('hideMenu', () => m.hidden = true));
        btns.forEach(b => b.addEventListener('mouseenter', pcEnter));
      };
      const unbindPC = () => {
        headerEl.removeEventListener('mouseleave', hideAll);
        noDropdowns.forEach(n => n.removeEventListener('mouseenter', hideAll));
        menus.forEach(m => m.removeEventListener('hideMenu', () => m.hidden = true));
        btns.forEach(b => b.removeEventListener('mouseenter', pcEnter));
      };

      // Mobile logic
      const mbClick = e => {
        e.preventDefault();
        const btn = e.currentTarget;
        if (btn === activeBtn) return hideAll();
        activeBtn?.classList.remove('active');
        activeBtn = btn;
        btn.classList.add('active');
        openMenu(btn);
      };
      const bindMB = () => btns.forEach(b => b.addEventListener('click', mbClick));
      const unbindMB = () => btns.forEach(b => b.removeEventListener('click', mbClick));

      // initial
      media.matches ? bindPC() : bindMB();
      media.addEventListener('change', () => {
        media.matches ? (unbindMB(), bindPC()) : (unbindPC(), bindMB());
      });
    }

    function initHeaderScroll() {
      const header = document.querySelector('header.header');
      if (!header) return;
      const hasShow = header.hasAttribute('data-scroll-show');
      const showDelay = Number(header.dataset.scrollShow) || 500;
      const startY = Number(header.dataset.scroll) || 1;

      let lastY = 0, timer, ticking = false;

      const onScroll = () => {
        const y = window.scrollY;
        if (y >= startY) {
          header.classList.add('header-scroll');
          if (hasShow) {
            header.classList.toggle('_header-show', y < lastY);
            clearTimeout(timer);
            timer = setTimeout(() => header.classList.add('_header-show'), showDelay);
          }
        } else {
          header.classList.remove('header-scroll', '_header-show');
        }
        lastY = y > 0 ? y : 0;
      };

      window.addEventListener('scroll', () => {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(() => {
            onScroll();
            ticking = false;
          });
        }
      });
    }
  }
});
